<!-- <div fxLayout="row" fxLayoutAlign="center center">
    <span> {{"view_time"|translate}} </span>
</div> -->

<ng-container *ngIf="this.form.get('date').value && timeslots?.length > 0">
    <h4 class="mt-4 mb-3">{{"select_time"|translate}}:</h4>
    <div class="flex flex-wrap gap-2">
        <div class="timeslot-item-container" *ngFor="let timeslot of timeslots; let index = index">
            <button class="timeslot-item" type="button" (click)="addRemoveTimeslot(index)" [ngClass]="{selected: isSelected(timeslot), second: true, third: false}">
                <div class="title">{{timeslot.range?.start | date: "shortTime"}}</div>
            </button>
            <!--   <div class="flex flex-row justify-center" *ngIf="selectedTimes[index]">
                <div>
                    <app-input-number aria-label="Quantity" class="product__quantity mt-1" size="lg" [min]="timeslot.minAmount"
                    [max]="timeslot.maxAmount" [step]="1" [formControl]="timeslot.control" (updatedItem)="setAmount(timeslot, $event)">
                    </app-input-number>
                    </div>
            </div> -->
        </div>
    </div>
</ng-container>

<!-- <div *ngIf="form.get('timeslots')?.value?.length > 0" fxLayout="column" style="min-width: 100%; margin-top: 21px" fxLayoutAlign="center center">
    <div fxLayout="row" style="min-width: 100%; margin-top: 21px" fxLayoutAlign="center center">
        <div class="list">
            <span class="m-4" fxFlexAlign="center"> {{"chosen_timeslots"|translate}}: </span>
            <div *ngFor="let timeslot of form.get('timeslots').value; let i = index" class="pt-2" >
                <div fxLayout="row" fxLayoutAlign="space-around center" class="timeslot-list-item" >
                    <span style=" text-align: center; margin-left: 5px; margin-right: 6px;">{{"from"|translate}}: {{ timeslot.range?.start | date: "shortTime" }}</span>
                    <span style=" text-align: center;">{{"to"|translate}}: {{ timeslot.range?.end | date: "shortTime" }}</span>
                    <button type="button" mat-icon-button (click)="removeTimeslot(i)"><mat-icon>close</mat-icon></button>
                </div>
            </div>
        </div>
    </div>
</div> -->
